// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.welcome {
  margin-left: 50px;
  margin-bottom: 60px;
  box-sizing: border-box;
  padding: 0px 94px 0px 24px;
}
.welcome .signupContent {
  border-bottom: 1px solid #d2d2d2;
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.welcome .welcome-btn-cancel {
  padding-top: 10px;
}
.welcome h2 {
  margin-bottom: 20px;
  top: 277px;
  left: 653px;
  width: 680px;
  height: 94px;
}
.welcome h2 span {
  display: block;
}
.welcome h1 {
  margin-top: 30px;
  margin-left: -15px;
}
.welcome .title-space {
  width: 52.66%;
  margin-top: 23px;
}
.welcome ul {
  margin-bottom: 20px;
  margin-left: -22px;
}
.welcome li {
  list-style-type: disc;
  margin-left: 40px;
  margin-bottom: 10px;
}
.welcome a {
  font-size: 18px;
}
.welcome .col-view {
  width: 44.66%;
}
@media (max-width: 1024px) {
  .welcome .col-view {
    width: 100%;
  }
}
.welcome .viewimg {
  top: 285px;
  left: 107px;
  width: 485px;
  height: 275px;
  margin-top: 30px;
  border-radius: 0px !important;
  margin-left: -12px;
}
@media only screen and (max-width: 1300px) and (min-width: 920px) {
  .welcome .viewimg {
    width: 355px;
  }
}
.welcome .botcont {
  padding-left: 5px;
}
.welcome .mediaStop {
  height: 277px;
}
.welcome .mediaPlay {
  height: auto;
}
.welcome .row {
  margin-top: 0px !important;
}
.welcome .box1 {
  top: 589px;
  left: 107px;
  width: 174px;
  height: 10px;
  background: #61CFFB 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: -12px;
  margin-top: 0px;
}
.welcome .box2 {
  top: 589px;
  left: 169px;
  width: 174px;
  height: 10px;
  background: #52B6EB 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 52px;
  margin-top: -10px;
}
.welcome .box3 {
  top: 589px;
  left: 232px;
  width: 174px;
  height: 10px;
  background: #3E9DD6 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 105px;
  margin-top: -10px;
}
.welcome .box4 {
  top: 589px;
  left: 293px;
  width: 174px;
  height: 10px;
  background: #3386C5 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 162px;
  margin-top: -10px;
}
.welcome .box5 {
  top: 589px;
  left: 366px;
  width: 174px;
  height: 10px;
  background: #286EB8 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 223px;
  margin-top: -10px;
}
@media only screen and (max-width: 1300px) and (min-width: 920px) {
  .welcome .box5 {
    width: 120px;
  }
}
.welcome .box6 {
  top: 589px;
  left: 418px;
  width: 175px;
  height: 10px;
  background: #1F56A9 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 267px;
  margin-top: -10px;
}
@media only screen and (max-width: 1300px) and (min-width: 920px) {
  .welcome .box6 {
    width: 76px;
  }
}
@media (max-width: 1024px) {
  .welcome {
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-left: 17px !important;
    padding: 0px 20px 0px 25px;
    padding-top: 50px;
  }
  .welcome .signupContent {
    padding-bottom: 20px;
    margin: 0 0 20px 0;
  }
  .welcome .welcome-btn-cancel {
    margin: 30px 0 0;
    padding-top: 0;
    padding-bottom: 0;
  }
  .welcome h1 {
    margin-left: 0px;
  }
  .welcome .btn-cancel {
    text-align: center;
    width: 100%;
  }
  .welcome .btn {
    text-align: center;
    width: 100%;
  }
  .welcome .title-space {
    margin-top: 10px;
    width: 100%;
  }
  .welcome .title-space p {
    margin-top: 270px;
    margin-left: -15px;
  }
  .welcome .title-space h2 {
    margin-top: -338px;
  }
  .welcome li {
    margin-left: 20px;
  }
  .welcome a {
    font-size: 16px;
  }
  .welcome h2 {
    margin-bottom: 20px;
    top: 277px;
    left: 653px;
    width: 300px;
    height: 94px;
    margin-left: -22px;
  }
  .welcome h2 span {
    display: block;
  }
  .welcome .viewimg {
    margin-top: 60px;
    top: 285px;
    left: 107px;
    width: 270px;
    height: 243px;
  }
  .welcome .row {
    margin-top: 0px !important;
  }
}
@media only screen and (max-width: 1024px) and (min-width: 350px) {
  .welcome .row {
    width: 300px;
  }
}
@media (max-width: 1024px) {
  .welcome .box1 {
    top: 589px;
    left: 107px;
    width: 124px;
    height: 7px;
    background: #61CFFB 0% 0% no-repeat padding-box;
    opacity: 1;
    margin-left: -12px;
    margin-top: 0px;
  }
  .welcome .box2 {
    top: 589px;
    left: 169px;
    width: 124px;
    height: 7px;
    background: #52B6EB 0% 0% no-repeat padding-box;
    opacity: 1;
    margin-left: 21px;
    margin-top: -7px;
  }
  .welcome .box3 {
    top: 589px;
    left: 232px;
    width: 124px;
    height: 7px;
    background: #3E9DD6 0% 0% no-repeat padding-box;
    opacity: 1;
    margin-left: 58px;
    margin-top: -7px;
  }
  .welcome .box4 {
    top: 589px;
    left: 293px;
    width: 124px;
    height: 7px;
    background: #3386C5 0% 0% no-repeat padding-box;
    opacity: 1;
    margin-left: 93px;
    margin-top: -7px;
  }
  .welcome .box5 {
    top: 589px;
    left: 366px;
    width: 80px;
    height: 7px;
    background: #286EB8 0% 0% no-repeat padding-box;
    opacity: 1;
    margin-left: 128px;
    margin-top: -7px;
  }
  .welcome .box6 {
    top: 589px;
    left: 418px;
    width: 93px;
    height: 7px;
    background: #1F56A9 0% 0% no-repeat padding-box;
    opacity: 1;
    margin-left: 165px;
    margin-top: -7px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/welcome/welcome.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAlJA;EACI,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;AAoJJ;AAnJI;EACI,gCAAA;EACA,oBAAA;EACA,mBAAA;AAqJR;AAlJI;EACE,iBAAA;AAoJN;AAlJI;EACI,mBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAoJR;AAnJQ;EACI,cAAA;AAqJZ;AAlJI;EACI,gBAAA;EACA,kBAAA;AAoJR;AAhJI;EACI,aAAA;EACA,gBAAA;AAkJR;AAhJI;EACI,mBAAA;EACA,kBAAA;AAkJR;AAhJI;EACI,qBAAA;EACA,iBAAA;EACA,mBAAA;AAkJR;AAhJI;EACI,eAAA;AAkJR;AA/II;EACE,aAAA;AAiJN;AA9II;EACE;IACE,WAAA;EAgJN;AACF;AA9II;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EAGA,6BAAA;EACA,kBAAA;AAgJR;AA9IQ;EAXJ;IAcM,YAAA;EA+IR;AACF;AA5II;EACI,iBAAA;AA8IR;AA3II;EACI,aAAA;AA6IR;AA3II;EACI,YAAA;AA6IR;AA1II;EACI,0BAAA;AA4IR;AAxII;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;AA0IR;AAtIM;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;AAwIR;AArIM;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAuIR;AApIM;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAsIR;AAnIM;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAqIR;AAnIQ;EAVF;IAaI,YAAA;EAoIR;AACF;AAjIM;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+CAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AAmIR;AAlIQ;EATF;IAYI,WAAA;EAmIR;AACF;AFjRI;EEvBJ;IAyKQ,mBAAA;IACA,sBAAA;IACA,4BAAA;IACA,0BAAA;IACA,iBAAA;EAmIN;EAlIM;IACI,oBAAA;IACA,kBAAA;EAoIV;EAlIM;IACI,gBAAA;IACA,cAAA;IACA,iBAAA;EAoIV;EAlIM;IACI,gBAAA;EAoIV;EAlIM;IACI,kBAAA;IACA,WAAA;EAoIV;EAlIM;IACI,kBAAA;IACA,WAAA;EAoIV;EAlIM;IACI,gBAAA;IACA,WAAA;EAoIV;EAnIU;IACI,iBAAA;IACA,kBAAA;EAqId;EAnIU;IACI,kBAAA;EAqId;EAlIM;IACI,iBAAA;EAoIV;EAlIM;IACI,eAAA;EAoIV;EA/HM;IACI,mBAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;EAiIV;EAhIU;IACI,cAAA;EAkId;EA/HM;IACI,gBAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,aAAA;EAiIV;EA/HM;IACI,0BAAA;EAiIV;AACF;AAhIY;EAHJ;IAIM,YAAA;EAmIZ;AACF;AFzVI;EEwNI;IACI,UAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,+CAAA;IACA,UAAA;IACA,kBAAA;IACA,eAAA;EAoIV;EAhIQ;IACE,UAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,+CAAA;IACA,UAAA;IACA,iBAAA;IACA,gBAAA;EAkIV;EA/HQ;IACE,UAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,+CAAA;IACA,UAAA;IACA,iBAAA;IACA,gBAAA;EAiIV;EA9HQ;IACE,UAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,+CAAA;IACA,UAAA;IACA,iBAAA;IACA,gBAAA;EAgIV;EA7HQ;IACE,UAAA;IACA,WAAA;IACA,WAAA;IACA,WAAA;IACA,+CAAA;IACA,UAAA;IACA,kBAAA;IACA,gBAAA;EA+HV;EA5HQ;IACE,UAAA;IACA,WAAA;IACA,WAAA;IACA,WAAA;IACA,+CAAA;IACA,UAAA;IACA,kBAAA;IACA,gBAAA;EA8HV;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.welcome {\n    margin-left: 50px;\n    margin-bottom: 60px;\n    box-sizing: border-box;\n    padding: 0px 94px 0px 24px;\n    .signupContent {\n        border-bottom: 1px solid color(default, dark);\n        padding-bottom: 30px;\n        margin-bottom: 30px;   \n    }\n\n    .welcome-btn-cancel {\n      padding-top: 10px;\n    }\n    h2 {\n        margin-bottom: 20px;\n        top: 277px;\n        left: 653px;\n        width: 680px;\n        height: 94px;\n        span {\n            display: block;\n        }\n    }\n    h1 {\n        margin-top: 30px;\n        margin-left: -15px;\n        //padding-bottom: 20px;\n    }\n\n    .title-space {\n        width: 52.66%;\n        margin-top: 23px;\n    }\n    ul {\n        margin-bottom: 20px;\n        margin-left: -22px;\n    }\n    li {\n        list-style-type: disc;\n        margin-left: 40px;\n        margin-bottom: 10px;\n    }\n    a {\n        font-size: 18px;\n    }\n\n    .col-view {\n      width: 44.66%;\n    }\n\n    @media (max-width: 1024px) {\n      .col-view {\n        width: 100%;\n      }\n    }\n    .viewimg {\n        top: 285px;\n        left: 107px;\n        width: 485px;\n        height: 275px;\n        margin-top: 30px;\n        -moz-border-radius: 0px !important; \n        -webkit-border-radius: 0px !important; \n        border-radius: 0px !important;\n        margin-left: -12px;\n\n        @media only screen and\n        (max-width: 1300px) and (min-width:920px) {\n\n          width: 355px;  \n        }\n    }\n\n    .botcont {\n        padding-left: 5px;\n    }\n\n    .mediaStop{\n        height:277px;\n    }\n    .mediaPlay{\n        height:auto;\n    }\n\n    .row{\n        margin-top: 0px !important; \n        //right:-25px;\n    }\n\n    .box1 {\n        top: 589px;\n        left: 107px;\n        width: 174px;\n        height: 10px;\n        background: #61CFFB 0% 0% no-repeat padding-box;\n        opacity: 1;\n        margin-left: -12px;\n        margin-top: 0px;\n        \n      }\n      \n      .box2 {\n        top: 589px;\n        left: 169px;\n        width: 174px;\n        height: 10px;\n        background: #52B6EB 0% 0% no-repeat padding-box;\n        opacity: 1;\n        margin-left: 52px;\n        margin-top: -10px;\n      }\n      \n      .box3 {\n        top: 589px;\n        left: 232px;\n        width: 174px;\n        height: 10px;\n        background: #3E9DD6 0% 0% no-repeat padding-box;\n        opacity: 1;\n        margin-left: 105px;\n        margin-top: -10px;\n      }\n      \n      .box4 {\n        top: 589px;\n        left: 293px;\n        width: 174px;\n        height: 10px;\n        background: #3386C5 0% 0% no-repeat padding-box;\n        opacity: 1;\n        margin-left: 162px;\n        margin-top: -10px;\n      }\n      \n      .box5 {\n        top: 589px;\n        left: 366px;\n        width: 174px;\n        height: 10px;\n        background: #286EB8 0% 0% no-repeat padding-box;\n        opacity: 1;\n        margin-left: 223px;\n        margin-top: -10px;\n\n        @media only screen and\n        (max-width: 1300px) and (min-width:920px) {\n\n          width: 120px;  \n        }\n      }\n      \n      .box6 {\n        top: 589px;\n        left: 418px;\n        width: 175px;\n        height: 10px;\n        background: #1F56A9 0% 0% no-repeat padding-box;\n        opacity: 1;\n        margin-left: 267px;\n        margin-top: -10px;\n        @media only screen and\n        (max-width: 1300px) and (min-width:920px) {\n\n          width: 76px;  \n        }\n      }\n\n      @include respond-to(small) {\n        margin-bottom: 30px;\n        box-sizing: border-box;\n        margin-left: 17px !important;\n        padding: 0px 20px 0px 25px;\n        padding-top: 50px;\n        .signupContent {\n            padding-bottom: 20px;\n            margin: 0 0 20px 0;\n        }\n        .welcome-btn-cancel {\n            margin: 30px 0 0;\n            padding-top: 0;\n            padding-bottom: 0;\n        }\n        h1 {\n            margin-left: 0px;\n        }\n        .btn-cancel {\n            text-align: center;\n            width: 100%;\n        }\n        .btn {\n            text-align: center;\n            width: 100%;\n        }\n        .title-space {\n            margin-top: 10px;\n            width: 100%;\n            p {\n                margin-top: 270px;\n                margin-left: -15px;\n            }\n            h2 {\n                margin-top: -338px;\n            }\n        }\n        li {\n            margin-left: 20px;\n        }\n        a {\n            font-size: 16px;\n        }\n        h1 {\n            //padding-left: 37px;\n        }\n        h2 {\n            margin-bottom: 20px;\n            top: 277px;\n            left: 653px;\n            width: 300px;\n            height: 94px;\n            margin-left: -22px;\n            span {\n                display: block;\n            }\n        }\n        .viewimg {\n            margin-top: 60px;\n            top: 285px;\n            left: 107px;\n            width: 270px;\n            height: 243px;  \n        }\n        .row{\n            margin-top: 0px !important; \n            //right:-25px;\n            @media only screen and (min-width: 350px) {\n              width: 300px;\n            }\n        }\n        .box1 {\n            top: 589px;\n            left: 107px;\n            width: 124px;\n            height: 7px;\n            background: #61CFFB 0% 0% no-repeat padding-box;\n            opacity: 1;\n            margin-left: -12px ;\n            margin-top: 0px;\n            \n          }\n          \n          .box2 {\n            top: 589px;\n            left: 169px;\n            width: 124px;\n            height: 7px;\n            background: #52B6EB 0% 0% no-repeat padding-box;\n            opacity: 1;\n            margin-left: 21px ;\n            margin-top: -7px;\n          }\n          \n          .box3 {\n            top: 589px;\n            left: 232px;\n            width: 124px;\n            height: 7px;\n            background: #3E9DD6 0% 0% no-repeat padding-box;\n            opacity: 1;\n            margin-left: 58px;\n            margin-top: -7px;\n          }\n          \n          .box4 {\n            top: 589px;\n            left: 293px;\n            width: 124px;\n            height: 7px;\n            background: #3386C5 0% 0% no-repeat padding-box;\n            opacity: 1;\n            margin-left: 93px ;\n            margin-top: -7px;\n          }\n          \n          .box5 {\n            top: 589px;\n            left: 366px;\n            width: 80px;\n            height: 7px;\n            background: #286EB8 0% 0% no-repeat padding-box;\n            opacity: 1;\n            margin-left: 128px ;\n            margin-top: -7px;\n          }\n          \n          .box6 {\n            top: 589px;\n            left: 418px;\n            width: 93px;\n            height: 7px;\n            background: #1F56A9 0% 0% no-repeat padding-box;\n            opacity: 1;\n            margin-left: 165px;\n            margin-top: -7px;\n          }\n        \n    }\n    \n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
